import { PageSection } from '@app/core/components/PageSection';
import { VideoJsPlayer } from '@app/core/video-player/video-js/VideoJsPlayer';
import { Box } from '@mui/material';
import { publishMessages } from '../publish-messages';

export interface VideoPreviewProps {
  /** URL of the video to preview. When null, nothing is rendered. */
  videoUrl: string | null;
}

/**
 * Preview of the media that will be uploaded to the social platform (shared compose + fragment upload wizard).
 */
export function VideoPreview({ videoUrl }: VideoPreviewProps) {
  if (!videoUrl) {
    return null;
  }

  return (
    <PageSection message={publishMessages.videoPreviewTitle}>
      <Box sx={{ borderRadius: 1, overflow: 'hidden', bgcolor: 'action.hover' }}>
        <VideoJsPlayer bordered src={videoUrl} sx={{ width: '100%', maxWidth: 1 }} />
      </Box>
    </PageSection>
  );
}
